import { makeRequest, makeRequestWithRetry } from 'src/utils/graphql';
import { ArticlesInstagramEntity } from '../types';
import { QUERY_ARTICLES_INSTAGRAM } from '../queries';
import { ArticlesInstagramActions } from './types';

import { instagramsToLoad } from '../queries';

export const fetchArticlesInstagramDataSSG = async () => {
  const response = await makeRequestWithRetry<{ instagrams: ArticlesInstagramEntity[] }>(
    QUERY_ARTICLES_INSTAGRAM,
    {},
    { errorId: 'fetchArticlesInstagramDataSSG()' }
  );

  return response;
};

export const fetchArticlesInstagramData = (isPagination = false) => {
  return async (dispatch, getState) => {
    dispatch(fetchArticlesInstagramDataBegin());

    const { instagrams, currentPage: prevCurrentPage } = getState()?.articles.instagrams;

    let currentPage = 0;

    let queryProps = {
      start: 0,
      limit: instagramsToLoad,
    };

    if (isPagination) {
      queryProps = {
        start: instagrams.length + instagramsToLoad * currentPage,
        limit: instagramsToLoad,
      };
      currentPage = prevCurrentPage + 1;
    }

    try {
      const response = await makeRequest<{ instagrams: ArticlesInstagramEntity[] }>(
        QUERY_ARTICLES_INSTAGRAM,
        queryProps
      );

      dispatch(fetchArticlesInstagramDataSuccess({ ...response, currentPage }));
    } catch (e) {
      dispatch(fetchArticlesInstagramDataError({ message: e.message }));
    }
  };
};

const fetchArticlesInstagramDataBegin = () => ({
  type: ArticlesInstagramActions.FetchBegin,
});

const fetchArticlesInstagramDataSuccess = (results) => ({
  type: ArticlesInstagramActions.FetchSuccess,
  payload: results,
});

const fetchArticlesInstagramDataError = (error) => ({
  type: ArticlesInstagramActions.FetchError,
  payload: { error },
});
